<div class="h-100">
  <div class="row h-100 no-gutters">
      <div class="d-none d-lg-block col-lg-4">
          <div class="slider-light">
                   <ngx-slick-carousel class="slick-slider slick-dotted" #slickModal="slick-carousel" [config]="slideConfig2">
          <div ngxSlickItem>
            <div class="position-relative h-100 d-flex justify-content-center align-items-center bg-happy-green">
              <div class="slide-img-bg"></div>
              <div class="slider-content text-light">
                <div class="mb-2 text-center d-inline"><img src="assets/images/fx-calculator.png"></div>
                <h3>SAVEDESK Calculator</h3>
                <p>Know what your bank is charging on each CASH ,TOM , SPOT , FORWARD & other FX related transaction. We don’t leave a stone unturned to help you optimise your FX cost.</p>
              </div>
            </div>
          </div>
          <div ngxSlickItem>
            <div class="position-relative h-100 d-flex justify-content-center align-items-center bg-happy-green">
              <div class="slide-img-bg"></div>
              <div class="slider-content text-light">
                <div class="mb-2 text-center d-inline"><img src="assets/images/alert.png"></div>
                <h3>Rate Alert</h3>
                <p>We don’t let you miss the FX RATE you want, ever! Jus relax, we shall do the tracking.</p>
              </div>
            </div>
          </div>
          <div ngxSlickItem>
            <div class="position-relative h-100 d-flex justify-content-center align-items-center bg-happy-green">
              <div class="slide-img-bg opacity-6"></div>
              <div class="slider-content text-light">
                <div class="mb-2 text-center d-inline"><img src="assets/images/record-transaction.png"></div>
                <h3>Record your Transactions</h3>
                <p>We let you record all the transactions you cover at a click of a button. Meticulous analytics to help you be on track with your Cost Optimisation journey.</p>
              </div>
            </div>
          </div>
          <div ngxSlickItem>
            <div class="position-relative h-100 d-flex justify-content-center align-items-center bg-happy-green">
              <div class="slide-img-bg opacity-6"></div>
              <div class="slider-content text-light">
                <div class="mb-2 text-center d-inline"><img src="assets/images/dashboard.png"></div>
                <h3>Dashing Dashboard</h3>
                <p>All your favourite currency pairs and Important FX events and information  at one place. Convenience of-course!</p>
              </div>
            </div>
          </div>
          <div ngxSlickItem>
            <div class="position-relative h-100 d-flex justify-content-center align-items-center bg-happy-green">
              <div class="slide-img-bg"></div>
              <div class="slider-content text-light">
                <div class="mb-2 text-center d-inline"><img src="assets/images/analysis.png"></div>
                <h3>Forex Margin Analysis</h3>
                <p>What gets measured gets managed. Know what you are paying & bring in absolute transparency.</p>
              </div>
            </div>
          </div>
        </ngx-slick-carousel>
          </div>
      </div>
      <div class="h-100 d-flex bg-white justify-content-center align-items-center col-md-12 col-lg-8">
          <div class="mx-auto app-login-box col-sm-12 col-md-8 col-lg-6">
              <div class="app-logo"></div>

              <div *ngIf="!invalidToken;else invalidTemplate">
             

                  <div *ngIf="!mailsent;else mailsentTemplate">     
                    <h4>
                    <div>Reset New Password</div>
                    <!-- <span>Use the form below to recover it.</span> -->
                </h4>
                      <form>
                          <div class="row">
                              <div class="col-md-12">
                                  <fieldset class="form-group" id="__BVID__133">
                                      <div tabindex="-1" role="group"><label for="exampleEmail">Password</label><input
                                              id="exampleEmail" name="email" type="password"
                                              placeholder="Password here..." [(ngModel)]="password"
                                              class="form-control" required>
                                      </div>
                                  </fieldset>
                                  <fieldset class="form-group" id="__BVID__133">
                                      <div tabindex="-1" role="group"><label for="exampleEmail">Confirm
                                              Password</label><input id="exampleEmail" name="email" type="password"
                                              placeholder="Repeat Password here..." [(ngModel)]="cpassword"
                                              class="form-control" required>
                                      </div>
                                  </fieldset>
                              </div>
                          </div>
                          <div class="mt-4 d-flex align-items-center">
                              <h6 class="mb-0"><a href="pages/login" class="text-primary">Sign in existing
                                      account</a></h6>
                              <div class="ml-auto">
                                  <button type="button" class="btn btn-success btn-lg"
                                      (click)="activatePassword()">Submit
                                  </button>
                              </div>
                          </div>
                          <h6 class="mb-12">Password Policy:</h6>
                          <div class="mt-12 d-flex align-items-center">
                            
                            Your password may be any combination of 6  to 40 letters ,numbers and special characters 
                            <br>* It is case sensitive
                            <br>* At least one Upper case
                            <br>* At least one Lower case
                            <br>* At least one Number case
                            <br>* At least one special characters from the folowing : @ $ ! % * ? &
                        </div>
                      </form>
                  </div>
                 
              </div>
              <ng-template #mailsentTemplate>
                <div class="row">
                  The New password updated sucessfully. Login with new credentials to continue...
                    <div class="mt-4 d-flex align-items-center">
                        <h6 class="mb-0"><a href="pages/login" class="text-primary">Sign in existing
                                account</a></h6>

                    </div>
                </div>
            </ng-template>
              <ng-template #invalidTemplate>
                  <ngb-alert type="danger" dismissible="false">
                      {{errorMessage}}
                  </ngb-alert>

                  <div class="row m-2">
                     
                      <div class="mt-4 d-flex align-items-center">
                          <h6 class="mb-0"><a href="pages/login" class="text-primary">Sign in existing
                                  account</a></h6>

                      </div>
                  </div>
              </ng-template>
          </div>
          <div style="position:fixed; bottom:0; width:50%; height:auto; margin-top:40px;text-align:center">
            <app-footer [needHelp]="true"></app-footer>
            </div>
      </div>
    
  </div>
  <app-loading *ngIf="loading"></app-loading>

</div>